module.exports = __webpack_public_path__ + "static/img/jiaotong-1.654d265.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaotong/jiaotong-1.png
// module id = wusF
// module chunks = 1